<template>

    <div class="container card p-5 shadow m-auto">
        
        <h1>Create Category</h1>
        <hr>
        
        <div v-if="response.success != null" v-bind:class="{ 'alert-success': response.success, 'alert-danger': !response.success }" class="alert" role="alert">
            {{response.message}}
        </div>

        <div id="form">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">{{$t("TITLE")}}</span>
                </div>
                <input v-model="category.title" type="text" class="form-control" :placeholder="$t('TITLE')">
            </div>
            <div class="form-group">
                <div class="input-group-prepend w-100">
                    <span class="input-group-text w-100">{{$t("DESCRIPTION")}}</span>
                </div>
                <html-editor v-model="category.description" />
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text">{{$t("LANGUAGE")}}</span>
                </div>
                <select v-model="category.languageId" class="custom-select" id="inputGroupSelect01">
                    <option v-for="(lang,index) in languages" :key="index" :selected='lang.title == category.languageId' :value="lang.id">
                        {{lang.longTitle}}
                    </option>
                </select>
            </div>
            <button @click="addCategory()" type="button" class="btn btn-primary mb-3 w-auto d-block">{{$t("ADD_CATEGORY")}}</button>
        </div>
    </div>

</template>

<script>
import HtmlEditor from './../../misc/HtmlEditor';
export default {
    data() {
        return {
            category: {
                title: null,
                description: null,
                languageId: ""
            },
            response: {},
            
        }
    },
    components: {
        HtmlEditor
    },
    computed: {
        languages() {
            return this.$store.getters.systemLanguages;
        }
    },
    methods: {
        addCategory: function(){
            let self = this;
                this.$http.post('/api/categories/add/', this.category)
                .then(response => {
                    self.response = response.data;
                })
                .catch(error => {
                    console.log(error);
                })
        },
    },
    mounted: function() {
    },
    watch: {
        response: function(val){
            if(val.success === true){
                setTimeout(() => {
                    this.$router.push(`/admin/categories`);
                }, 1000)
            }
            setTimeout(() => {
                this.response.success = null;
            }, 3000) 
        },      
    }
    
}
</script>

<style scoped lang="scss">
</style>